/** 美国 NowPay 生产开关；设为 false 可临时屏蔽前端 USD 入口。IP 门禁见 deposit-us-pay-guard.js */
export const TOPPAY_US_FRONTEND_ENABLED = true;
/** 印度 MGM 生产已开通；设为 false 可临时屏蔽前端 INR 入口。 */
export const TOPPAY_INDIA_FRONTEND_ENABLED = true;
/** 菲律宾 TopPay Global；与 BE toppay_ph_enabled 同轮上线。BE 未开时 supported 无 PH，前端不会露出。 */
export const TOPPAY_PH_FRONTEND_ENABLED = true;

/** TopPay region ↔ fiat currency mapping (backend models.TopPayRegion*). */
export const TOPPAY_FIAT_CURRENCIES = Object.freeze([
  'VND',
  'BRL',
  'MXN',
  'PHP',
  'INR',
  'IDR',
  'USD',
]);

export const TOPPAY_CURRENCY_TO_REGION = Object.freeze({
  VND: 'VN',
  BRL: 'BR',
  MXN: 'MX',
  PHP: 'PH',
  INR: 'IN',
  USD: 'US',
});

export const TOPPAY_REGION_TO_CURRENCY = Object.freeze({
  VN: 'VND',
  BR: 'BRL',
  MX: 'MXN',
  PH: 'PHP',
  IN: 'INR',
  US: 'USD',
});

export function currencyToTopPayRegion(currency) {
  const code = String(currency ?? '')
    .trim()
    .toUpperCase();
  return TOPPAY_CURRENCY_TO_REGION[code] || '';
}

export function isTopPayFiatCurrency(currency) {
  const code = String(currency ?? '')
    .trim()
    .toUpperCase();
  if (!TOPPAY_INDIA_FRONTEND_ENABLED && code === 'INR') return false;
  if (!TOPPAY_US_FRONTEND_ENABLED && code === 'USD') return false;
  if (!TOPPAY_PH_FRONTEND_ENABLED && code === 'PHP') return false;
  return TOPPAY_FIAT_CURRENCIES.includes(code);
}

/** Force-disable IN region after API parse when frontend gate is off. */
export function stripIndiaFromTopPayRegions(regions) {
  if (TOPPAY_INDIA_FRONTEND_ENABLED || !regions || typeof regions !== 'object') {
    return applyUsTopPayRegionGate(regions);
  }
  const next = { ...regions };
  if (next.IN) {
    next.IN = { ...next.IN, enabled: false, methods: [] };
  }
  return applyUsTopPayRegionGate(next);
}

/** Force-disable US region after API parse when frontend gate is off. */
export function applyUsTopPayRegionGate(regions) {
  let next = regions;
  if (!TOPPAY_US_FRONTEND_ENABLED && regions && typeof regions === 'object') {
    next = { ...regions };
    if (next.US) {
      next.US = { ...next.US, enabled: false, methods: [] };
    }
  }
  return applyPhTopPayRegionGate(next);
}

/** Force-disable PH region after API parse when frontend gate is off. */
export function applyPhTopPayRegionGate(regions) {
  if (TOPPAY_PH_FRONTEND_ENABLED || !regions || typeof regions !== 'object') {
    return regions;
  }
  const next = { ...regions };
  if (next.PH) {
    next.PH = { ...next.PH, enabled: false, methods: [] };
  }
  return next;
}

/** Remove gated fiat rows from cash fiat picker (Alchemy + TopPay merge). */
export function filterIndiaFiatCurrencyRows(rows) {
  let out = rows;
  if (!TOPPAY_INDIA_FRONTEND_ENABLED) {
    out = (Array.isArray(out) ? out : []).filter(
      (row) =>
        String(row?.currency ?? '')
          .trim()
          .toUpperCase() !== 'INR'
    );
  }
  if (!TOPPAY_US_FRONTEND_ENABLED) {
    out = (Array.isArray(out) ? out : []).filter(
      (row) =>
        String(row?.currency ?? '')
          .trim()
          .toUpperCase() !== 'USD' ||
        String(row?.country ?? '')
          .trim()
          .toUpperCase() !== 'US'
    );
  }
  if (!TOPPAY_PH_FRONTEND_ENABLED) {
    out = (Array.isArray(out) ? out : []).filter(
      (row) =>
        String(row?.currency ?? '')
          .trim()
          .toUpperCase() !== 'PHP'
    );
  }
  return out;
}

export function topPayAmountDecimals(regionOrCurrency) {
  const raw = String(regionOrCurrency ?? '')
    .trim()
    .toUpperCase();
  if (raw === 'VN' || raw === 'VND') return 0;
  if (
    raw === 'BR' ||
    raw === 'BRL' ||
    raw === 'MX' ||
    raw === 'MXN' ||
    raw === 'PH' ||
    raw === 'PHP' ||
    raw === 'IN' ||
    raw === 'INR' ||
    raw === 'ID' ||
    raw === 'IDR' ||
    raw === 'US' ||
    raw === 'USD'
  ) {
    return 2;
  }
  return 2;
}

export function isUsDirectUsdRegion(region) {
  return String(region ?? '').trim().toUpperCase() === 'US';
}

/** PH Global OpenAPI：纯收银台，不展示/不强制 method。 */
export function isTopPayCashierRegion(region) {
  return String(region ?? '').trim().toUpperCase() === 'PH';
}
